module.exports = __webpack_public_path__ + "img/chambers-of-xeric.6c272208.jpg";